export enum TELEHEALTH_MODE
{
	REGULAR = "regular",
	AQS = "aqs",
	PUBLIC = "public",
}
